import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { fatchLogout } from '../../store/auth-actions';
import { initTexts } from "../../store/translate-actions";
import useReplaceNumChar from '../../hooks/useReplaceNumChar'
import classes from "./UserInfo.module.css";
import avatar_1 from '../../assests/user-profile/avaters_selected/avatar_selected_1.png'
import avatar_2 from '../../assests/user-profile/avaters_selected/avatar_selected_2.png'
import avatar_3 from '../../assests/user-profile/avaters_selected/avatar_selected_3.png'
import avatar_4 from '../../assests/user-profile/avaters_selected/avatar_selected_4.png'
import avatar_5 from '../../assests/user-profile/avaters_selected/avatar_selected_5.png'
import avatar_6 from '../../assests/user-profile/avaters_selected/avatar_selected_6.png'
import avatar_7 from '../../assests/user-profile/avaters_selected/avatar_selected_7.png'
import avatar_8 from '../../assests/user-profile/avaters_selected/avatar_selected_8.png'
import defaultAvatar from '../../assests/user-profile/default-avatar.png'
import { usersApi } from '../../utils'
import { throwApiError } from "../lms-shared/store/error-handling-actions";
import { initLmsUser } from '../../store/auth-actions';
import UserProfile from "../lms-shared/UI/UserProfile";
import { onKeyDown } from "../../service";

const UserInfo = ({ hideUserInfo }) => {
    const user = useSelector(state => state.auth.user);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const texts = useSelector(state => state.translate.texts);
    const [showEditProfile, setShowEditProfile] = useState(false)
    const dispatch = useDispatch()
    const numClass = useReplaceNumChar()
    const avatars = [avatar_1, avatar_2, avatar_3, avatar_4, avatar_5, avatar_6, avatar_7, avatar_8]

    const changeProfile = async (avatar) => {
        let res = await fetch(avatar);
        let blobRes = await res.blob()
        const opts = {
            profileImage: blobRes
        }
        usersApi.usersUpdatePost(opts, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.usersUpdateError, error: error, statusCode: response?.statusCode, message: "usersUpdatePost " + error.message, level: 1, component: "ChangeUserProfilePopup", line: 33 }))
            } else {
                dispatch(initLmsUser())
            }
        })
    }

    function changeLang(lang) {
        try {
            if (localStorage.getItem('LANG') !== lang) {
                localStorage.setItem('LANG', lang)
                dispatch(initTexts)
                window.location.reload();
            }
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div className={`${classes.UserInfo} ${showEditProfile && classes.ShowEdit}`}>
            <div className={classes.UserInfoContainer}>
                <UserProfile width="105px"
                    image={user.profileImage ?
                        `${user.profileImage}` :
                        defaultAvatar}
                >
                    <div className={classes.EditImg} onClick={() => setShowEditProfile((prev) => { return !prev })} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowEditProfile((prev) => { return !prev }))}></div>
                </UserProfile>
                <div className={`${hideUserInfo ? classes.HideUserInfo : classes.UserName}`}>
                    <div className={classes.UserTextWarp}>{user.firstName} {user.lastName}</div>
                    <div className={classes.UserSchoolInfo}>
                        {user?.class ? <div>{numClass(user.class)}'</div>:''}
                    </div>
                </div>
                {showEditProfile &&
                    <div className={classes.EditProfile}>
                        {avatars.map((a, i) =>
                            <div className={`${classes.EditProfileImg} ${classes[`EditProfileImg${i + 1}`]}`} key={i} onClick={() => changeProfile(a)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeProfile(a))}>
                            </div>
                        )}
                    </div>
                }
                <div className={classes.UserLang}>
                    <div className={classes.MyLang}>{texts.myLang}</div>
                    <div className={classes.LangBtns}>
                        <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'he' ? classes.CurrentLang : ''}`} onClick={() => changeLang('he')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('he'))}>ע</div>
                        <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'ar' ? classes.CurrentLang : ''}`} onClick={() => changeLang('ar')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('ar'))}>ع</div>
                        <div className={`${classes.LangBtn} ${localStorage.getItem('LANG') === 'en' ? classes.CurrentLang : ''}`} onClick={() => changeLang('en')} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeLang('en'))}>E</div>
                    </div>
                </div>
            </div>
            <div className={classes.Logout} onClick={() => fatchLogout(homeUrl)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => fatchLogout(homeUrl))}>{texts.logout}</div>
        </div>
    )
}
export default UserInfo